import { type MCPServerInfo } from '../../types';

const HoneycombServer: MCPServerInfo = {
  serverId: 'HONEYCOMB',
  name: 'Honeycomb',
  slug: 'honeycomb',
  description:
    'Honeycomb MCP Server - Query, analyze, and visualize observability data including traces, triggers, and SLOs using natural language.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.honeycomb.io/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default HoneycombServer;
